// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1srtL","overflowing":"ReadFullNote_overflowing__2HJf9"};